/**
 * @flow
 * @relayHash dff99bca00210854b8712af4401be2aa
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type QuotationCreateInput = {|
  title: string,
  description?: ?string,
  address: string,
  date: any,
  tax?: ?string,
  discountType?: ?string,
  discountValue?: ?string,
  total: string,
  totalTTC: string,
  billingAddressId?: ?string,
  currencyId: string,
  customerId: string,
  quotationItem: $ReadOnlyArray<QuotationItemCreateInput>,
|};
export type QuotationItemCreateInput = {|
  projectId: string,
  designation: string,
  description?: ?string,
  quantity: string,
  unityId: string,
  discount?: ?string,
  unitPrice: string,
  total: string,
|};
export type CreateQuotationMutationVariables = {|
  data: QuotationCreateInput
|};
export type CreateQuotationMutationResponse = {|
  +createQuotation: {|
    +id: string
  |}
|};
export type CreateQuotationMutation = {|
  variables: CreateQuotationMutationVariables,
  response: CreateQuotationMutationResponse,
|};
*/


/*
mutation CreateQuotationMutation(
  $data: QuotationCreateInput!
) {
  createQuotation(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "QuotationCreateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createQuotation",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "QuotationModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateQuotationMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateQuotationMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateQuotationMutation",
    "id": null,
    "text": "mutation CreateQuotationMutation(\n  $data: QuotationCreateInput!\n) {\n  createQuotation(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fe80f9edcdf929981f8a63e401d24a93';
module.exports = node;
